import { useLocation, useNavigate } from 'react-router-dom';

import { isGuidesView, leaveGuidesLocation } from './integrationGuidesRoute';

export type GuidesBack = {
  leavesGuides: boolean;
  goBack: (() => void) | undefined;
};

export const useGuidesBack = (isCloudflareBeta: boolean, onGoBack?: () => void): GuidesBack => {
  const location = useLocation();
  const navigate = useNavigate();
  const leavesGuides = isCloudflareBeta && isGuidesView(location.search);

  return {
    leavesGuides,
    goBack: leavesGuides
      ? () => navigate(leaveGuidesLocation(location.search), { replace: true })
      : onGoBack,
  };
};
